// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__6PtkZ"};